<template>
  <v-list-item density="compact" v-if="product != null" class="border-bottom list-cart pa-0">
    <v-row class="ma-0">
      <v-col class="v-col-2 v-col-sm-1 v-col-lg-2 d-flex align-center justify-center cursor-pointer" @click="Details()">
        <ImageProduct :image="product.image"></ImageProduct>
      </v-col>
      <v-col class="v-col-10 v-col-sm-11 v-col-lg-10 text-color-0 text-small text-start">
        <v-row>
          <v-col class="v-col-12 v-col-sm-9 text-color-0 text-small text-start pb-0 px-2">
            <div class="list-cart-title cursor-pointer" @click="Details()">
            {{ product.name }}
            </div>
          </v-col>
          <v-col class="v-col-12 v-col-sm-3 d-flex align-center justify-start pb-2 pt-1 px-1">
            <v-chip class="text-center bg-color-2" v-if="product.cashback > 0">
              <b class="text-xsmall text-center text-color-white text-break"><span class="text-nowrap">Cashback</span> <span class="text-bold text-nowrap">{{ $formatNumber(product.cashback, {style: 'currency', currency: 'BRL'}) }}</span></b>   
            </v-chip>      
          </v-col>
        </v-row>
        <v-row v-if="block == false">
          <v-col class="v-col-9 v-col-sm-9 d-flex align-center justify-center pb-2 pt-1 px-2">
            <v-btn icon="mdi-chat-outline" variant="tonal" size="small" :class="product.cart.obs != '' && product.cart.obs != null ? 'bg-color-1 text-color-white':'grey' " class="br-5 me-2" @click="modelObs = !modelObs"></v-btn>
            <v-text-field variant="outlined" density="compact" :hide-details="true" v-model="textQtd" readonly class="text-center" v-if="kgund == 1">
              <template v-slot:prepend-inner>
                <v-icon icon="mdi-trash-can-outline" size="x-small" class="cursor-pointer" @click="removeAll()" />
                <v-icon icon="mdi-minus" size="x-small" class="cursor-pointer ms-2" @click="removeItem()" />
              </template>
              <template v-slot:append-inner>
                <v-icon icon="mdi-plus" size="x-small" class="cursor-pointer" @click="addItem()" />
              </template>
            </v-text-field>
            <v-text-field variant="outlined" density="compact" :hide-details="true" v-model="qtd" v-maska:[maskqtd] :readonly="product.cfg != null && product.cfg.fractional_amount > 1 ? true: false" class="text-center" @keyup="updateItem()" v-else>
              <template v-slot:prepend-inner>
                <v-icon icon="mdi-trash-can-outline" size="x-small" class="cursor-pointer" @click="removeAll()" />
                <v-icon icon="mdi-minus" size="x-small" class="cursor-pointer ms-2" @click="removeItem()" />
              </template>
              <template v-slot:append-inner>
                <v-icon icon="mdi-plus" size="x-small" class="cursor-pointer" @click="addItem()" />
              </template>
            </v-text-field>
          </v-col>
          <v-col class="v-col-3 v-col-sm-3 d-flex align-center justify-end pb-2 pt-1 ps-1 pe-3 text-medium">
            <b>{{ $formatNumber(product.total, {style: 'currency', currency: 'BRL'}) }}</b>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="v-col-6 d-flex align-center justify-start pt-1 px-2 pb-0 text-medium">
            <b v-if="product.cart.type_unit == 1">{{ textQtd }}</b>
            <b v-else>{{ qtd }} <span v-if="qtd > 1">unds</span><span v-else>und</span></b>
          </v-col>
          <v-col class="v-col-6 d-flex align-center justify-end pt-1 ps-1 pe-3 pb-0 text-medium">
            <b>{{ $formatNumber(product.total, {style: 'currency', currency: 'BRL'}) }}</b>
          </v-col>
          <v-col class="v-col-12" v-if="product.cart.obs != '' && product.cart.obs != null">
            <b>Obs:</b> {{ product.cart.obs }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-list-item>
  <DialogObs :fechar="fechar" :model="modelObs" :item="product"></DialogObs>
</template>
<script>
import ImageProduct from '@/components/ImageProduct.vue';
import DialogObs from '@/components/DialogObs.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'ProductList',
  components: {
    ImageProduct,
    DialogObs
  },
  props: {
    product: {
      type: Object,
      default: null
    },
    block: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      modelObs: false,
      qtd: 0,
      kgund: 0,
      maskqtd: {
        mask: "####",
      },
    }
  },
  computed: {
    ...mapGetters('cart', {
      getItemById: 'getItemById'
    }),
    item: function() {
      let retorno = this.product ? this.getItemById(this.product.sku) : null;
      return retorno ? JSON.parse(JSON.stringify(retorno)) : null;
    },
    textQtd: function () {
      if (this.qtd < 1) {
          return Number(Math.round((this.qtd * 1000) + 'e0') + 'e-0')+'g';
      } else {
          return Number.isInteger(this.qtd) ? (Number(Math.round((this.qtd) + 'e0') + 'e-0')+'kg').replace(".", ",") : (Number(Math.round((this.qtd) + 'e3') + 'e-3').toFixed(3)+'kg').replace(".", ",")
      }
    }
  },
  watch: {
    item(i) {
      this.qtd = i != null ? i.cart.amount : 0;
      this.kgund = i != null ? i.cart.type_unit : 0;
      if(this.product.image == undefined){
        this.getImageCarousel({ sku: this.product.sku, imghash: this.product.imghash }).then(function(image){
          this.product.image = image;
        }.bind(this));
      }
    },
  },
  methods: {
    ...mapActions('cart', {
      updateItemCart: 'updateItemCart',
    }),
    ...mapActions('products', {
      addProduct: 'addProduct',
      getImageCarousel: 'getImageCarousel'
    }),
    updateItem(){
      let qtd = this.verifyMinimum(this.qtd, this.qtd);
      this.qtd = qtd;
      this.setQtd(parseFloat(this.qtd));
    },
    setQtd(qtd){
      if(qtd == null){
        qtd = this.product.cfg != null && this.product.cfg.minimum_amount > 0 ? this.product.cfg.minimum_amount : 1;
      }
      if(this.product.limit_quantity > 0 && this.product.limit_quantity < qtd){
        this.emitter.emit('dialogMessage', { title: "Atenção", message: "Produto com limitação de estoque, no momento apenas é permitido a compra de " + this.product.limit_quantity + " " +(this.product.is_kg == 1 ? 'kg' : 'unds') });
        this.qtd = this.product.limit_quantity;
      } else {
        this.updateItemCart({ item: this.product, qtd: qtd, kgund: this.kgund }).then(function (){
          this.qtd_buffer = 0;
          this.emitter.emit('sendCart');
        }.bind(this));
      }
    },
    addItem(){
      let qtd = this.qtd;
      if(qtd == 0){
        qtd = this.product.cfg != null && this.product.cfg.minimum_amount > 0 ? this.product.cfg.minimum_amount : 1;
        if(this.product.is_kg == 1 && this.product.cfg.net_weight > 0 && this.kgund == 0){
          qtd = Number(Math.round((parseFloat(qtd) / parseFloat(this.product.cfg.net_weight)) + 'e0') + 'e-0');
          qtd = qtd < 1 ? 1 : qtd;
          qtd = this.verifyMinimum(qtd, qtd);
        }
      } else {
        let q = (this.product.cfg != null && this.product.cfg.fractional_amount > 0 ? this.product.cfg.fractional_amount : 1);
        if(this.product.is_kg == 1 && this.product.cfg.net_weight > 0 && this.kgund == 0){
          q = Number(Math.round((parseFloat(q) / parseFloat(this.product.cfg.net_weight)) + 'e0') + 'e-0');
          q = q < 1 ? 1 : q;
        }
        qtd = parseFloat(qtd) + parseFloat(q);
      }
      if(this.product.limit_quantity > 0 && this.product.limit_quantity < qtd){
        this.emitter.emit('dialogMessage', { title: "Atenção", message: "Produto com limitação de estoque, no momento apenas é permitido a compra de " + this.product.limit_quantity + " " +(this.product.is_kg == 1 ? 'kg' : 'unds') });
      } else {
        this.updateItemCart({ item: this.product, qtd: qtd, kgund: this.kgund }).then(function (){
          this.emitter.emit('sendCart');
        }.bind(this));
      }
    },
    removeItem(){
      let qtd = this.product.cfg != null && this.product.cfg.fractional_amount > 0 ? this.product.cfg.fractional_amount : 1;
      if(this.product.is_kg == 1 && this.product.cfg.net_weight > 0 && this.kgund == 0){
        qtd = Number(Math.round((parseFloat(qtd) / parseFloat(this.product.cfg.net_weight)) + 'e0') + 'e-0');
        qtd = qtd < 1 ? 1 : qtd;
      }
      qtd = this.verifyMinimum(parseFloat((parseFloat(this.qtd) - parseFloat(qtd)).toFixed(3)), qtd);
      this.updateItemCart({ item: this.product, qtd: parseFloat((parseFloat(this.qtd) - parseFloat(qtd)).toFixed(3)), kgund: this.kgund }).then(function (){
        this.emitter.emit('sendCart');
      }.bind(this));
    },
    removeAll(){
      this.updateItemCart({ item: this.product, qtd: 0 }).then(function (){
        this.emitter.emit('sendCart');
      }.bind(this));
    },
    verifyMinimum(qtd, qtd_nova){
      let qtd_temp = qtd_nova;
      if(this.product.cfg != null){
        if(this.product.is_kg == 1 && this.product.cfg.net_weight > 0 && this.kgund == 0){
          if(qtd < Number(Math.round((this.product.cfg.minimum_amount / this.product.cfg.net_weight) + 'e0') + 'e-0')){
            qtd_temp = parseFloat(qtd) + parseFloat(qtd_nova);
          }
        } else {
          if(qtd < this.product.cfg.minimum_amount){
            qtd_temp = parseFloat(qtd) + parseFloat(qtd_nova);
          }
        }
      }
      return qtd_temp;
    },
    Details(){
      this.addProduct(this.product);
      this.$router.push('/details/'+this.product.barcode);
    },
    fechar: function(){
      this.modelObs = false;
    },
  },
  mounted(){
    if(this.item && this.item.cart){
      this.qtd = this.item.cart.amount;
      this.kgund = this.item.cart.type_unit;
    } else {
      this.kgund = this.product.is_kg == 1;
    }
    this.getImageCarousel({ sku: this.product.sku, imghash: this.product.imghash }).then(function(image){
      this.product.image = image;
    }.bind(this));
  } 
}
</script>